/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState, createContext, useContext } from "react";
import { useGetApplicationSettings } from "utils/apis/common.api";

export default function LoginAgreement() {
  const { isUserVerified, verifyUser, unVerifyUser } = useUserAgreement();

  const { mutate: getAppSettings, data: appSettingsRes } =
    useGetApplicationSettings();
  useEffect(() => {
    if (!isUserVerified) {
      getAppSettings();
    }
  }, []);

  const Swal = require("sweetalert2");

  useEffect(() => {
    if (appSettingsRes && !isUserVerified) {
      const messageObj = appSettingsRes;
      Swal.fire({
        title: "User Agreement",
        text: messageObj.logonMessage,
        showCancelButton: true,
        confirmButtonText: "Agree",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked "Agree"
          verifyUser();
          localStorage.setItem("is-user-verified", "true");
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // User clicked "Cancel"
          unVerifyUser();
          window.top?.postMessage(
            { type: "logout" },
            process.env.REACT_APP_ADMIN,
          );
          localStorage.removeItem("is-user-verified");
          sessionStorage.clear();
        }
      });
    }
  }, [appSettingsRes]);
  return <div className="w-[100vw] h-[100vh] bg-white" />;
}

const UserAgreementContext = createContext();

export function UserAgreementProvider({ children }) {
  const [isUserVerified, setIsUserVerified] = useState(() => {
    return localStorage.getItem("is-user-verified") === "true";
  });

  const verifyUser = () => {
    localStorage.setItem("is-user-verified", "true");
    setIsUserVerified(true);
  };

  const unVerifyUser = () => {
    localStorage.removeItem("is-user-verified");
    sessionStorage.clear();
    setIsUserVerified(false);
  };

  return (
    <UserAgreementContext.Provider
      value={{ isUserVerified, verifyUser, unVerifyUser }}
    >
      {children}
    </UserAgreementContext.Provider>
  );
}

export const useUserAgreement = () => useContext(UserAgreementContext);
